<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="新增销售"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onSubmit" ref="formRef">
        <div class="main-info-wrap">
          <div class="main-info-title">销售信息</div>
          <!-- 姓名 -->
          <van-field
              v-model.trim="form.userName"
              name="userName"
              label="姓名"
              placeholder="请输入姓名"
              required
              trigger="blur"
              :rules="[{ required: true, message: '请输入姓名' }]"
          />
          <!-- 手机号 -->
          <van-field
              v-model.trim="form.phoneNumber"
              name="phoneNumber"
              label="手机号"
              placeholder="请输入手机号"
              type="tel"
              required
              :rules="[{ required: true, message: '请输入手机号' }, { pattern: mobileReg, message: '请输入合法的手机号' }]"
          />
        </div>

        <!-- 提交按钮 -->
        <div style="margin: 16px;">
          <van-button class="submit-btn" round block type="info" native-type="submit">
            保存
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { Toast } from 'vant';
import { addOrUpdateSaleUser } from '@/api/sales';

export default {
  data() {
    return {
      form: {
        userName: '',
        phoneNumber: ''
      },
      mobileReg: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
    };
  },
  methods: {
    onClickLeft() {
      this.$router.push('/sale_manage');
    },
    async onSubmit() {
      try {
        await this.$refs.formRef.validate();
        const res = await addOrUpdateSaleUser({
          nickName: this.form.userName,
          phonenumber: this.form.phoneNumber,
          userName: this.form.phoneNumber
        });
        if (res.code === 200) {
          Toast(res.returnMsg || '保存成功');
          setTimeout(() => {
            this.$router.replace('/sale_manage');
          }, 800);
        } else {
          Toast(res.returnMsg || '保存失败，请重试');
        }
      } catch (error) {
        if (error && error.name === 'ValidateError') {
          Toast('请检查必填项是否填写正确');
        } else {
          Toast('提交失败，请稍后重试');
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}

::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}

.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}

.container-item {
  margin-bottom: 60px;
  padding: 0 8px;
}

.submit-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
}

.main-info-wrap {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  margin: 15px;

  @media (min-width: 768px) {
    padding: 15px 70px;
  }

  .main-info-title {
    font-size: 18px;
    font-weight: bold;
    color: #222;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;

    @media (min-width: 768px) {
      font-size: 30px;
      margin-bottom: 10px;
      padding-bottom: 10px;
    }
  }
}

::v-deep .van-field__control {
  min-height: auto;
}
</style>
